@if (product()) {
    <div class="content-container p-24:t p-32:b md:p-32:t md:p-48:b lg:p-48:t lg:p-64:b">
        <div class="grid-container">
            <div
                class="g-12"
                [ngClass]="{
                    'md:g-8': !product()?.orderConfig.hideSummarySidebarOnLandingPage,
                }"
            >
                <app-product-description-fallback (next)="next.emit({})"></app-product-description-fallback>
            </div>
            @if (!product()?.orderConfig.hideSummarySidebarOnLandingPage) {
                <div class="g-4 hide md:block">
                    <app-info-sidebar [product]="product()"></app-info-sidebar>
                </div>
            }
        </div>
    </div>
}
